import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const SET_DEFAULT_CAPTCHA_TYPE = 'SET_DEFAULT_CAPTCHA_TYPE';
const SET_ONLY_FAIL_VALID_COUNTER = 'SET_ONLY_FAIL_VALID_COUNTER';
const SET_ASC_CAPTCHA_TYPE = 'SET_ASC_CAPTCHA_TYPE';
const SEND_REQUEST_GET_CAPTCHA = 'SEND_REQUEST_GET_CAPTCHA';
const UPDATE_DATA = 'UPDATE_DATA';
const REQUEST_FINISHED = 'REQUEST_FINISHED';

const reducerDotPath = `main.states.captcha`;
const createActionName = name => `app/${reducerDotPath}/${name}`;

// Типы капчи
const defaultType = 'default';
const onlyFailValidCounter = 'only_fail_valid_counter';
const askType = 'ask';

const createReducer = () => {
  function stateDefault() {
    return {
      ...createRequestState(),
      type: defaultType,
      data: {
        answer: [],
        isFailValidCounterFull: null,
        imageBase64: null
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(SET_DEFAULT_CAPTCHA_TYPE):
        return state.merge({ type: defaultType });
      case createActionName(SET_ONLY_FAIL_VALID_COUNTER):
        return state.merge({ type: onlyFailValidCounter });
      case createActionName(SET_ASC_CAPTCHA_TYPE):
        return state.merge({ type: askType });
      case createActionName(REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(SEND_REQUEST_GET_CAPTCHA):
        return setRequestStateInProgress(state);
      case createActionName(UPDATE_DATA):
        return state.merge({ data: action.payload || {} });
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTION REGISTER
export const initState = () => ({
  type: createActionName(INIT_STATE)
});
export const setDefaultCaptchaType = () => ({
  type: createActionName(SET_DEFAULT_CAPTCHA_TYPE)
});
export const setOnlyFailValidCounter = () => ({
  type: createActionName(SET_ONLY_FAIL_VALID_COUNTER)
});
export const setAscCaptchaType = () => ({
  type: createActionName(SET_ASC_CAPTCHA_TYPE)
});
export const requestFinished = (codeResponse, hasSuccess) => ({
  type: createActionName(REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequestGetCaptcha = (hasRegenerate = false) => ({
  type: createActionName(SEND_REQUEST_GET_CAPTCHA),
  payload: { hasRegenerate }
});
export const updateData = payload => ({
  type: createActionName(UPDATE_DATA),
  payload
});

// SELECTORS
export const getState = state => _.get(state, reducerDotPath);
export const selectRequestState = state =>
  _.get(getState(state), 'requestState');

export function selectType(state) {
  return getState(state).type;
}
export function selectData(state) {
  return getState(state).data;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/reducers/static/states/captcha/reducer.js